<div class="transaction-wrap transactiontopheight" #transactionWrap *ngIf="account?.walletAddress"
    [ngClass]="showtransactiondetail?'sucessview':''">
    <div class="collapse-arrow cursor-pointer" [ngClass]="isView ? 'mt-8' : 'mt-1'" (click)="showTransacation()">
        <img src="assets/images/transacation-arrow.svg" alt="transaction collapse" width="24" height="24">
        <!-- Revealed on hover; the tab reads as an icon until then. -->
        <span class="collapse-arrow__label">Transactions</span>
        <div class="badges" *ngIf="transactions?.length != 0 && viewTransactionDetails?.['count']">
            {{this.viewTransactionDetails?.['count'] > 99 ? '99+' : this.viewTransactionDetails?.['count']}}
        </div>
    </div>
    <div class="transaction-details" [ngClass]="showtransactiondetail?'sucessview':''">
        <!--sticky top-->
        <div class="staticview">
            <div class="d-flex align-items-center justify-content-between mb-18">
                <div class="d-flex align-items-center">
                    <h3>Transaction.</h3>
                    <div *ngIf="transactions?.length != 0" class="badges-secondary">{{totalDocs}}
                    </div>
                </div>
                <div class="hide-arrow cursor-pointer" title="Close" (click)="showTransacation()">
                    <img src="assets/images/transacation-arrow.svg" alt="transaction collapse" width="16" height="16">
                </div>
            </div>
            <!--searchbar-->
            <div class="position-relative">
                <input type="text" #searchBox id="search-box" class="form-control" (input)="transactionLoader = true;"
                    [formControl]="searchControl" placeholder="Search transaction.">
                <div class="searchIcon">
                    <img src="assets/images/transacation-search.svg" alt="search" width="24" height="24">
                </div>
            </div>
            <!--end-->
        </div>
        <!--end-->
        <!-- No divider under the search: the sticky header casts a shadow once the
             list scrolls beneath it, which separates the two only when needed. -->
        <!--approve-->
        <!-- .scroll has no height/overflow of its own (see the commented-out rule in the CSS);
             the panel that actually scrolls is .transaction-wrap, so infinite scroll listens there. -->
        <div class="scroll" infinite-scroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="100"
            [infiniteScrollContainer]="transactionWrap"
            (scrolled)="onScroll()" [scrollWindow]="false" [infiniteScrollDisabled]="disableInfiniteScroll">
            <!-- One card per call: what happened (thumbnail, operation, asset), its state
                 and time, then the contract and hash as a quiet two-column footer. The
                 contract used to be repeated in a header row above the operation; it now
                 lives only in the footer. -->
            <div class="transaction-card" *ngFor="let transaction of transactions; let transactionIndex = index; trackBy: trackByTransaction" id="">
                <div class="txn-card__main">
                    <!-- Not every logged call is about an asset: the deposit fee is paid
                         before anything is minted, so those rows fall back to an icon for
                         the operation and name it instead of the asset (see thumbnailFor). -->
                    <div class="nft_image">
                        <img [src]="transaction.thumbnail | pinataThumbnail: 88"
                            appImageFallback
                            (load)="imageLoading = false" alt="transaction">
                    </div>
                    <div class="txn-card__title">
                        <h5>{{transaction.transaction_name | uiTerminology}}.</h5>
                        <h6 *ngIf="transaction.active_nft?.name">{{transaction.active_nft?.name | uiTerminology}}.</h6>
                    </div>
                    <a class="txn-card__open cursor-pointer" title="View details"
                        (click)="openTransactionDetailsPopup(transaction, transaction.active_nft)"><img
                            src="assets/images/transacation-external.svg" alt="" width="16" height="16"></a>
                </div>

                <div class="txn-card__state">
                    <span class="txn-status txn-status--progress" *ngIf="transaction.status === 0">Inprogress.</span>
                    <span class="txn-status txn-status--success" *ngIf="transaction.status === 1">Success.</span>
                    <!-- The chip clips long chain errors to one line; the wrapper carries
                         the full text as a tooltip on hover or keyboard focus. -->
                    <span class="txn-status-tip" *ngIf="transaction.status === 2" tabindex="0"
                        [attr.data-tip]="transaction.error_message + '.'">
                        <span class="txn-status txn-status--failed">{{transaction.error_message}}.</span>
                    </span>
                    <time class="txn-card__date">{{transaction.createdAt | readableDate}}.</time>
                </div>
                <div class="progress" role="progressbar" aria-label="Transaction in progress" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100" *ngIf="transaction.status === 0">
                    <div class="progress-bar approve" style="width: 30%"></div>
                </div>

                <div class="nftitems" *ngIf="transaction.nft_id.length > 1">
                    <div *ngFor="let nfts of transaction.nft_id; let nftIndex = index">
                        <div class="normalview"
                            [ngClass]="{'active': activeIndices[transactionIndex] === nftIndex}">
                            <img *ngIf="nfts?.fileType !== 'html'"
                                [src]="((nfts?.primary_media ? nfts?.primary_media : nfts?.secondary_media?.[0]) || 'assets/images/default-nft.svg') | pinataThumbnail: 88"
                                appImageFallback
                                alt="img" width="40" height="40"
                                (click)="setActiveIndex(transactionIndex, nftIndex)">

                            <img *ngIf="nfts?.fileType === 'html'"
                                [src]="(nfts?.preview_image ? nfts?.preview_image : nfts?.secondary_media[0]) | pinataThumbnail: 88"
                                appImageFallback
                                (load)="imageLoading = false" alt="nft" class="img-fluid" width="40"
                                height="40" (click)="setActiveIndex(transactionIndex, nftIndex)">
                        </div>
                    </div>
                </div>

                <div class="user-detail">
                    <div class="txn-meta">
                        <h5>Contract.</h5>
                        <div class="d-flex walletaddress_tooltip" id="tooltip-head">
                            <h6 (window:resize)="setTooltipSize()" class="position-relative"
                                id="tooltip-title">{{transaction.to?.slice(0,
                                5)}}...{{transaction.to?.slice(transaction.to.length - 4)}}.
                                <span class="tooltip" id="tooltip-description">
                                    {{transaction.to}}
                                </span>
                            </h6>
                            <button type="button" class="txn-meta__action" title="Copy address"
                                (click)="copyAddress(transaction.to)"><img src="assets/images/copy-wallet.svg"
                                    alt="copy"></button>
                        </div>
                    </div>
                    <div class="txn-meta">
                        <h5>Tx hash.</h5>
                        <div class="d-flex align-items-center">
                            <p>{{transaction.transaction_hash?.slice(0,
                                5)}}...{{transaction.transaction_hash?.slice(transaction.transaction_hash.length
                                -
                                4)}}.</p>
                            <a class="txn-meta__action" *ngIf="transaction.status" target="_blank" rel="noopener"
                                title="View on explorer"
                                href="{{transhUrl}}/tx/{{transaction.transaction_hash}}">
                                <img *ngIf="transaction.transaction_hash"
                                    src="assets/images/transacation-external.svg" alt="" width="14"
                                    height="14"></a>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="transactions?.length == 0 && !transactionLoader">
                <div class="notfound-transaction">
                    <div class="text-center">
                        <img src="assets/images/no-found-transaction.png" alt="no transaction" class="img-fluid mb-3">
                        <h6>No transaction found.</h6>
                    </div>
                </div>
            </ng-container>
        </div>
        <ng-container *ngIf="transactionLoader">
            <div class="loadingview">
                <h6>Loading.</h6>
                <span class="Loaders"></span>
            </div>
        </ng-container>
       
    </div>
</div>

<!-- Transaction details Modal starts -->
<div class="modal fade" [config]="{backdrop: 'static', keyboard: false}" bsModal #transactionDetailsModal="bs-modal"
    tabindex="-1" role="dialog">
    <app-transaction-details-modal [transactionModalData]="transactionModalData"
        (closeModal)="closeTransactionModal()"></app-transaction-details-modal>
</div>
<!-- Transaction details Modal ends -->
